import {createSlice} from '@reduxjs/toolkit';
import {
  getPuntosVenta,
  getTypes,
  editPuntoVenta,
  newPuntoVenta,
  deletePuntoVenta,
  changeCategoryActive,
} from '../../api/PuntosVenta';

export const puntosVentaSlice = createSlice({
  name: 'puntosVenta',
  initialState: {
    puntosVenta: [],
  },
  reducers: {
    setPuntosVenta: (state, action) => {
      console.log("entro",action.payload)
      state.puntosVenta = action.payload;
    },
    setActive: (state, action) => {
      const {category, val} = action.payload;
      const index = state.categories.findIndex(el => el.id === category)
      state.categories[index].active = val;
    },
    setPuntoVenta: (state, action) => {
      const index = state.puntosVenta.findIndex(el => el.id === action.payload.id);
      if (index > -1) {
        state.puntosVenta[index] = action.payload;
      }
    },
    addPuntoVenta: (state, action) => {
      state.puntosVenta.push(action.payload);
    },
    removePuntoVenta: (state, action) => {
      const index = state.puntosVenta.findIndex(el => el.id === action.payload);
      if (index > -1) {
        state.puntosVenta.splice(index, 1);
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const {setPuntosVenta, setActive, addPuntoVenta, setPuntoVenta, removePuntoVenta} = puntosVentaSlice.actions;

export const getAllPuntosVenta = () => async dispatch => {
  try {
    const response = await getPuntosVenta();
    if (!response.error && response.status === 200) {
      dispatch(setPuntosVenta(response.data));
      return {
        status: 'success',
      };
    }
    return {
      status: 'error',
      type: 'unkown'
    };
  } catch (e) {
    return {
      status: 'error',
      type: 'unknown',
    };
  }
};


export const getTypesList = () => async () => {
  try {
    const response = await getTypes();
    if (!response.error && response.status === 200) {
      return {
        status: 'success',
        types: response.data,
      };
    }
    return {
      status: 'error',
      type: 'unkown'
    };
  } catch (e) {
    return {
      status: 'error',
      type: 'unknown',
    };
  }
};

export const activeCategory = (id, val) => async dispatch => {
  try {
    dispatch(setActive({category: id, val: !val}));
    const response = await changeCategoryActive(id);
    if (!response.error && response.status === 200) {
      return {
        status: 'success',
      };
    }
    dispatch(setActive({category: id, val}));
    return {
      status: 'error',
      type: 'unkown'
    };
  } catch (e) {
    dispatch(setActive({category: id, val}));
    return {
      status: 'error',
      type: 'unknown',
    };
  }
};

export const updatePuntoVenta = (id, data) => async dispatch => {
  try {
    const response = await editPuntoVenta(id, data);
    if (!response.error && response.status === 200) {
      if (response.data?.status === 300) {
        return {
          status: 'error',
          type: 'incomplete',
        };
      }
      dispatch(setPuntoVenta(response.data));
      return {
        status: 'success',
      };
    }
    return {
      status: 'error',
      type: 'unkown'
    };
  } catch (e) {
    return {
      status: 'error',
      type: 'unknown',
    };
  }
};

export const createPuntoVenta = data => async dispatch => {
  try {
    const response = await newPuntoVenta(data);
    if (!response.error && response.status === 200) {
      if (response.data?.status === 300) {
        return {
          status: 'error',
          type: 'incomplete',
        };
      }
      dispatch(addPuntoVenta(response.data))
      return {
        status: 'success',
        category: response.data,
      };
    }
    return {
      status: 'error',
      type: 'unkown'
    };
  } catch (e) {
    return {
      status: 'error',
      type: 'unknown',
    };
  }
};

export const deletePuntoVentaMonitor = id => async dispatch => {
  try {
    const response = await deletePuntoVenta(id);
    if (!response.error && response.status === 200) {
      dispatch(removePuntoVenta(id));
      return {
        status: 'success',
        // departments: response.data,
      };
    }
    return {
      status: 'error',
      type: 'unkown'
    };
  } catch (e) {
    return {
      status: 'error',
      type: 'unknown',
    };
  }
};

export const listPuntoVenta = state => state.puntosVenta;

export default puntosVentaSlice.reducer;
